import styled from '@emotion/styled';

export const SmallGreyText = styled('p')`
  margin: 0;
  color: var(--767676-members-page);
`;
